import { render, staticRenderFns } from "./GridCards.vue?vue&type=template&id=0477f2d7"
import script from "./GridCards.vue?vue&type=script&lang=js"
export * from "./GridCards.vue?vue&type=script&lang=js"
import style0 from "./GridCards.vue?vue&type=style&index=0&id=0477f2d7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports